var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchRadar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hinava_random_uuid_264430963812608834409854542404963132989",
    cx: "0%",
    cy: "100%",
    r: "100.099%",
    fx: "0%",
    fy: "100%",
    gradientTransform: "scale(.98734 1) rotate(-44.657 0 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFD6",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-.807 -.447)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hinava_random_uuid_264430963812608834409854542404963132989)",
    d: "M157.807 82.447c0-43.078-35.004-78-78.185-78l-.772 73.958c-.023 2.21 1.749 4.019 3.958 4.042h74.999z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "360 80.807 80.447",
    to: "0 80.807 80.447",
    dur: "3s",
    additive: "sum",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 80.807,
    cy: 80.447,
    r: 57.81,
    stroke: "#FFF",
    strokeOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.807,
    cy: 80.447,
    r: 46.18,
    stroke: "#FFF",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.807,
    cy: 80.447,
    r: 34.54,
    stroke: "#FFF",
    strokeOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.807,
    cy: 80.447,
    r: 22.9,
    stroke: "#FFF",
    strokeOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRadar);
export default __webpack_public_path__ + "static/media/search-radar.9ba36ac7ab9c3cf8102f73c475cddf3a.svg";
export { ForwardRef as ReactComponent };